var map = {
	"./game_tiyu_bangqiu.png": "23b3",
	"./game_tiyu_basketball-copy.png": "c31c",
	"./game_tiyu_basketball.png": "702e",
	"./game_tiyu_default.png": "06d0",
	"./game_tiyu_football-copy.png": "15a4",
	"./game_tiyu_football.png": "6245",
	"./game_tiyu_meishizuqiu.png": "e605",
	"./game_tiyu_paiqiu.png": "29ab",
	"./game_tiyu_pingpang.png": "34ea",
	"./game_tiyu_quanji.png": "cdbc",
	"./game_tiyu_sinuoke.png": "c44e",
	"./game_tiyu_tennis.png": "eafc",
	"./game_tiyu_yumaoqiu.png": "eece"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3229";